
import { Component, Vue, Prop } from 'vue-property-decorator'
import { StationClient, EmployeeClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'EmployeeEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  @Prop({ default: -1 })
  private stationId !: number

  private stationClient : StationClient
  private stationList = []
  public constructor() {
    super()
    this.client = new EmployeeClient()
    this.stationClient = new StationClient()
    this.data = {
      stationId: this.stationId,
      name: null,
      sex: null,
      nation: null,
      birthday: null,
      home_address: null,
      id_card_number: null,
      mobile_phone_number: null
    }
    this.rules = {
      stationId: [{ required: true, message: '气站为必选项', trigger: 'blur' }],
      name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
      sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
      nation: [{ required: true, message: '民族不能为空', trigger: 'blur' }],
      birthday: [{ required: true, message: '生日不能为空', trigger: 'blur' }],
      home_address: [{ required: true, message: '家庭住址不能为空', trigger: 'blur' }],
      id_card_number: [{ required: true, message: '身份证号码不能为空', trigger: 'blur' }],
      mobile_phone_number: [{ required: true, message: '手机号码不能为空', trigger: 'blur' }]
    }
  }

  public async reset() {
    this.data = {
      stationId: this.stationId,
      name: null,
      sex: null,
      nation: null,
      birthday: null,
      home_address: null,
      id_card_number: null,
      mobile_phone_number: null
    }
  }

  protected generateData(): any {
    this.data.id_card_number = String(this.data.id_card_number)
    this.data.mobile_phone_number = String(this.data.mobile_phone_number)
    return this.data
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getStationList()
  }

  private async getStationList() {
    this.stationList = await this.stationClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true
        },
        order: ['createdAt']
      }
    })
  }
}
